import gql from 'graphql-tag';

const RETRIEVE_TOKEN = gql`
  mutation retrieveToken($username: String!, $password: String!, $tradename: String) {
    retrieveToken(username: $username, password: $password, tradename: $tradename) {
      token
    }
  }
`;

export {RETRIEVE_TOKEN};
